import { ExplainerLayout } from '@/components/ExplainerLayout';
import { KPIR_ELEKTRONICZNA } from '@/content/przewodniki';

const KpirElektroniczna2026 = () => <ExplainerLayout guide={KPIR_ELEKTRONICZNA} />;

export default KpirElektroniczna2026;
